// src/hooks/useCenterServices.js
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { fetchCenterServices } from "../Api/CenterServices";

export const useCenterServices = () => {
  const defaultOptions = {
    staleTime: 1000 * 60 * 5, // 5 minutes cache
  };

  const queryClient = useQueryClient();

  // Get center services query
  const centerServicesQuery = useQuery({
    queryKey: ["centerServices"],
    queryFn: () => fetchCenterServices(),
    staleTime: defaultOptions.staleTime,
    enabled: defaultOptions.enabled,
  });

  return {
    centerServicesQuery,
    services: centerServicesQuery.data,
    isLoading: centerServicesQuery.isLoading,
    isError: centerServicesQuery.isError,
    error: centerServicesQuery.error,
  };
};

